<template>
  <div>
  <el-dialog :model-value="showPhoneNumberForm" width="500px" @close="showPhoneNumberForm = false" class="custom-dialog">
    <p class="instruction-text">Enter Phone Number</p>
    <div>
      <el-form ref="phoneNumberFormRef" label-position="top" :model="phoneNumberForm" :rules="phoneNumberFormRules" class="phone-number-form">
        <el-form-item label="Phone Number" prop="phoneNumber">
          <el-input :model-value="phoneNumberForm.phoneNumber" @update:model-value="value => phoneNumberForm.phoneNumber = value" class="phone-input"></el-input>
        </el-form-item>
        <el-button id="submitPhoneNumberBtn" @click="onSendVerificationCode" class="send-code-button">Send Verification Code</el-button>
      </el-form>
    </div>
  </el-dialog>

  <el-dialog :model-value="showPhoneNumberCodeForm" width="500px" @close="showPhoneNumberCodeForm = false" class="custom-dialog">
    <p class="instruction-text">Validate Phone Number</p>
    <p style="text-align: center;">Code was sent to {{ phoneNumberForm.phoneNumber }}</p>
    <div class="mt-3">
      <el-form ref="phoneNumberCodeFormRef" label-position="top" :model="phoneNumberCodeForm" :rules="phoneNumberCodeFormRules" class="phone-number-form">
        <el-form-item label="Verification Code" prop="code">
          <el-input :model-value="phoneNumberCodeForm.code" @update:model-value="value => phoneNumberCodeForm.code = value" class="phone-input"></el-input>
        </el-form-item>
        <el-button @click="onConfirmVerificationcode" class="send-code-button">Validate</el-button>
      </el-form>
    </div>
  </el-dialog>
  <Form
    ref="form"
    class="mt-4"
    :validation-schema="schema"
    @submit="firebaseRegister"
    v-slot="{ errors }"
  >
    <div>
      <div class="form-group">
        <label for="firstName">First Name</label>
        <Field
          name="firstName"
          class="form-control mb-0"
          :class="{ 'is-invalid': errors['name'] }"
          id="firstName"
          v-model="user.firstName"
          placeholder="Your first name"
        />
        <div class="invalid-feedback">
          <ErrorMessage name="firstName" />
        </div>
      </div>
      <div class="form-group">
        <label for="lastName">Last Name</label>
        <Field
          name="lastName"
          class="form-control mb-0"
          :class="{ 'is-invalid': errors['name'] }"
          id="lastName"
          v-model="user.lastName"
          placeholder="Your last name"
        />
        <div class="invalid-feedback">
          <ErrorMessage name="name" />
        </div>
      </div>
      <div class="form-group">
        <label for="emailInput">Email address</label>
        <Field
          name="email"
          class="form-control mb-0"
          :class="{ 'is-invalid': errors['email'] }"
          id="emailInput"
          v-model="user.email"
          placeholder="Enter email"
        />
        <div class="invalid-feedback">
          <ErrorMessage name="email" />
        </div>
      </div>
      <div class="form-group">
        <label for="passwordInput">Password</label>
        <Field
          name="password"
          class="form-control mb-0"
          :class="{ 'is-invalid': errors['password'] }"
          id="passwordInput"
          v-model="user.password"
          type="password"
          placeholder="Password"
        />
        <div class="invalid-feedback">
          <ErrorMessage name="password" />
        </div>
      </div>
      <div class="form-group">
        <label for="confirmPassword">Confirm Password </label>
        <Field
          name="confirmPassword"
          class="form-control mb-0"
          :class="{ 'is-invalid': errors['confirmPassword'] }"
          id="confirmPassword"
          type="password"
          placeholder="Confirm Password"
        />
        <div class="invalid-feedback">
          <ErrorMessage name="confirmPassword" />
        </div>
      </div>
      <div class="d-inline-block w-100">
      <div class="custom-control custom-checkbox d-inline-block mt-2 pt-1">
        <input
          type="checkbox"
          class="custom-control-input"
          id="isDoctor"
          name="isDoctor"
          v-model="user.isDoctor"
        />
        <label class="custom-control-label" for="isDoctor">Sign up as a doctor</label>
      </div>
    </div>
      <div class="d-inline-block w-100">
        <div class="custom-control custom-checkbox d-inline-block mt-2 pt-1">
          <Field
            type="checkbox"
            class="custom-control-input"
            :id="formType"
            name="terms"
            :value="false"
          />
          <label class="custom-control-label" :for="formType"
            >I accept
            <a target="_blank" href="https://texavie.com/terms-and-conditions/"
              >Terms and Conditions</a
            ></label
          >
        </div>
        <button
          type="submit"
          id="signUpButton"
          class="btn btn-primary float-right"
        >
          Sign Up
        </button>
      </div>
      <div class="sign-info">
        <span class="dark-color d-inline-block line-height-2">
          Already Have Account ?
          <router-link
            to="/dark/auth/sign-in1"
            class="iq-waves-effect pr-4"
            v-if="$route.meta.dark"
          >
            Sign in
          </router-link>
          <router-link to="/auth/sign-in1" class="iq-waves-effect pr-4" v-else>
            Sign in
          </router-link>
        </span>
        <social-login-form></social-login-form>
      </div>
    </div>
  </Form>
  </div>
</template>

<script>
import auth from '../../../../services/auth'
import SocialLoginForm from './SocialLoginForm'
import { Field, Form, ErrorMessage } from 'vee-validate'
import * as yup from 'yup'
import { setDoc, doc } from '@firebase/firestore'
import firebaseService from '../../../../../firebase'
import { ref } from 'vue'
import { useRouter } from 'vue-router'
import {
  createUserWithEmailAndPassword,
  OAuthProvider,
  sendEmailVerification,
  PhoneAuthProvider,
  RecaptchaVerifier,
  deleteUser,
  linkWithCredential,
  signInWithPhoneNumber,
  fetchSignInMethodsForEmail,
  EmailAuthProvider,
  signInWithPopup,
  updateProfile
} from 'firebase/auth'
import { getDoc } from 'firebase/firestore'
import Modal from '../../../../components/Modal.vue'
import { httpsCallable } from 'firebase/functions'
import { ElMessage, ElMessageBox } from 'element-plus'

const provider = new OAuthProvider('apple.com')

export default {
  name: 'SignUp1Form',
  components: { SocialLoginForm, Field, Form, ErrorMessage, Modal },
  props: ['formType'],
  setup () {
    const addDoctorClaim = httpsCallable(firebaseService.functions, 'addDoctorClaim')

    const schema = yup.object({
      email: yup.string().required().email(),
      firstName: yup.string().required(),
      lastName: yup.string().required(),
      password: yup.string().required().min(8),
      terms: yup.boolean().required(),
      confirmPassword: yup
        .string()
        .oneOf([yup.ref('password'), null], 'Passwords must match')
    })

    let signUpObject = null
    let authObject = null
    let shouldLinkToApple = false
    const user = ref({
      email: '',
      password: '',
      firstName: '',
      lastName: '',
      isDoctor: false
    })
    const showPhoneNumberForm = ref(false)
    const showPhoneNumberCodeForm = ref(false)
    const verificationId = ref(null)
    const error = ref(null)
    const error2 = ref(null)
    const router = useRouter()
    const phoneNumberFormRef = ref(null)
    const phoneNumberCodeFormRef = ref(null)
    const phoneNumberForm = ref(
      {
        phoneNumber: ''
      }
    )
    const phoneNumberCodeForm = ref(
      {
        code: ''
      }
    )
    const phoneNumberFormRules = ref({
      phoneNumber: [
        { required: true, message: 'Please enter a valid phone number', trigger: 'blur' }
      ]
    })
    const phoneNumberCodeFormRules = ref({
      code: [
        { required: true, message: 'Please enter a valid code', trigger: 'blur' }
      ]
    })

    const firebaseRegister = async (submittedObject) => {
      const signInMethods = await fetchSignInMethodsForEmail(
        firebaseService.firebaseAuth,
        submittedObject.email
      )
      if (signInMethods.length === 1 && signInMethods[0] === 'apple.com') {
        if (
          !confirm(
            'Do you want to create this account and link it to your existing apple account?'
          )
        ) {
          return
        } else {
          shouldLinkToApple = true
        }
      } else if (signInMethods.length > 0) {
        ElMessage({
          message: 'You already have an account.',
          type: 'error'
        })
        return
      }
      showPhoneNumberForm.value = true
      signUpObject = submittedObject
    }

    const onSendVerificationCode = async () => {
      phoneNumberFormRef.value.validate(async (valid) => {
        if (valid) {
          await sendVerificationCode()
          showPhoneNumberForm.value = false
          showPhoneNumberCodeForm.value = true
        }
      })
    }

    const onConfirmVerificationcode = async () => {
      phoneNumberCodeFormRef.value.validate(async (valid) => {
        if (valid) {
          showPhoneNumberCodeForm.value = false
          confirmVerificationcode()
        }
      })
    }

    const sendVerificationCode = async () => {
      const phone = phoneNumberForm.value.phoneNumber
      if (!phone) return
      error.value = null
      const applicationVerifier = new RecaptchaVerifier(
        'submitPhoneNumberBtn',
        { size: 'invisible' },
        firebaseService.firebaseAuth
      )
      // Get the verification code from user
      try {
        authObject = await signInWithPhoneNumber(
          firebaseService.firebaseAuth,
          '+1' + phone,
          applicationVerifier
        )
        error.value = 'Code sent'
      } catch (err) {
        console.log(err)
        error.value = 'There was an error. Try again signing up again.'
      }
    }
    const confirmVerificationcode = () => {
      const submittedObject = signUpObject
      const authCredential = PhoneAuthProvider.credential(
        authObject.verificationId,
        phoneNumberCodeForm.value.code
      )
      if (shouldLinkToApple) {
        const emailCredential = EmailAuthProvider.credential(
          submittedObject.email,
          submittedObject.password
        )
        signInWithPopup(firebaseService.firebaseAuth, provider)
          .then(async (result) => {
            await linkWithCredential(
              firebaseService.firebaseAuth.currentUser,
              emailCredential
            )
            await linkWithCredential(
              firebaseService.firebaseAuth.currentUser,
              authCredential
            )
            await updateProfile(result.user, {
              displayName:
                submittedObject.firstName + ' ' + submittedObject.lastName
            })
            router.push('/')
          })
          .catch((error) => {
            ElMessage({
              message: error.message,
              type: 'error'
            })
          })
        return
      }
      createUserWithEmailAndPassword(
        firebaseService.firebaseAuth,
        submittedObject.email,
        submittedObject.password
      )
        .then(async (userCreds) => {
          const currentUser = firebaseService.firebaseAuth.currentUser
          const linkedUser = await linkWithCredential(
            currentUser,
            authCredential
          )
          error2.value = 'Loading...'
          await updateProfile(linkedUser.user, {
            displayName:
              submittedObject.firstName + ' ' + submittedObject.lastName
          })
          if (user.value.isDoctor) {
            const ref = doc(firebaseService.db, 'doctors', linkedUser.user.uid)
            const docSnapshot = await getDoc(ref)
            if (!docSnapshot.exists()) {
              await setDoc(
                doc(firebaseService.db, 'doctors', linkedUser.user.uid),
                {
                  firstName: submittedObject.firstName,
                  lastName: submittedObject.lastName,
                  patients: []
                }
              )
            }
          } else {
            const ref = doc(firebaseService.db, 'users', linkedUser.user.uid)
            const docSnapshot = await getDoc(ref)
            if (!docSnapshot.exists()) {
              await setDoc(
                doc(firebaseService.db, 'users', linkedUser.user.uid),
                {
                  firstName: submittedObject.firstName,
                  lastName: submittedObject.lastName,
                  email: submittedObject.email
                }
              )
            }
          }
          sendEmailVerification(linkedUser.user)
          ElMessageBox.alert(`A verification email has been ${user.value.email}. Please check your inbox to complete the email verification process.`, 'Email Verification Needed', {
            confirmButtonText: 'OK',
            callback: (action) => {
              router.push('/auth/sign-in1')
            }
          })
        })
        .catch((err) => {
          ElMessage({
            message: err.message,
            type: 'error'
          })
          if (firebaseService.firebaseAuth.currentUser) {
            deleteUser(firebaseService.firebaseAuth.currentUser)
          }
          error2.value =
            'Error: Refresh the page and try again. Your account was not created.'
        })
    }

    return {
      schema,
      showPhoneNumberForm,
      verificationId,
      error,
      error2,
      firebaseRegister,
      sendVerificationCode,
      confirmVerificationcode,
      user,
      phoneNumberForm,
      phoneNumberFormRules,
      phoneNumberFormRef,
      onSendVerificationCode,
      showPhoneNumberCodeForm,
      phoneNumberCodeForm,
      phoneNumberCodeFormRules,
      phoneNumberCodeFormRef,
      onConfirmVerificationcode
    }
  }
}
</script>

<style scoped>

.instruction-text {
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 20px;
  text-align: center;
}

.send-code-button {
  width: 100%;
  color: white;
}

.invalid-feedback span {
  color: red;
}
</style>
